module.exports = __webpack_public_path__ + "static/thomas-jefferson-building-0ff324d55584b0318dd278a74f8e5731.jpg";